import { v7 } from 'uuid';

export const createUuidV7 = (): string => v7();

export const uuidV7Pattern =
  /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

export const isUuidV7 = (value: unknown): value is string =>
  typeof value === 'string' && uuidV7Pattern.test(value);

export const defaultOrganizationId = '01a13da3-4d90-7000-a35e-ebf2b4cdae67';
export const membershipSettingsId = '01a13da3-4d90-7001-8428-0139adb88626';
